<template>
  <div>
    <div class="app-content" v-if="source != null">
      <vue-pdf-embed 
        id="page"
        :source="source" 
        @rendered="createAnnotationLayersePerPage" 
        :page="page"
        :width="pageWidth"
        :scale="pageScale"
        :rotation="rotation"
        @password-requested="handlePasswordRequest"
        ref="pdfViewer"
        :textLayer="showTextLayer"
        :annotationLayer="showAnnotationLayer"
      />
    </div>
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import pdfUtils from '@/utils/pdfUtils.js'
import bookUtils from '@/utils/bookUtils.js'
import annotationUtils from '@/utils/annotationUtils.js'
import storeHelpers from '@/utils/storeHelpers.js'
import ContextMenu from '../annotations/ContextMenu'
import AnnotationLayer from '../../../../../static/libs/pdf/pdfWizard/annotationLayer.js'
import { clearTimeout } from 'highcharts'

import Notification from "@/components/notifications/Notification";
require('../../../../../static/libs/pdf/pdfWizard/annotationLayer.css')

export default {
  name: 'PDFViewer2',
  components: {
    VuePdfEmbed,
    ContextMenu,
    Notification
  },
  props: {
      book: {
      type: Object,
      required: true,
    },
    currentPage: {
      type: Object,
      required: true
    },
    metadata: {
      type: Object,
      required: true,
    },
    scaleZoom: {
      type: Number,
      required: true
    },
    resourcePanelOpen: {
      type: Boolean,
      required: true
    },
    flashcardDeckEditor: {
      type: Boolean,
      required: true
    },
    highlights: {
      type: Object,
      required: true
    },
    drawings: {
      type: Object,
      required: true
    },
    onPageLoading: Function,
    onCurrentPageChanged: Function,
    onCurrentScaleChanged: Function,
    showAnnotations: {
      type: Boolean,
      required: true
    },
    contextMenuListItemOpen: {
      type: Boolean,
      required: true
    },
    hlPenMode: {
      type: String,
      required: true
    },
    hlPenSettings: {
      type: Object,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    showSearchMode: {
      type: Boolean,
      required: true
    },
    undoCalled: {
      type: Number,
      required: true
    },
    redoCalled: {
      type: Number,
      required: true
    },
    selectedVoice: {
      required: false
    },
    voiceList: {
      required: false
    },
    textToSpeechRate: {
      required: false
    },
    textToSpeechVolume: {
      required: false
    },
    TTSPlaying: {
      type: Boolean,
      required: true
    },
    TTSPaused: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      PDFPERPAGE: 100,
      contextMenu: {
        el: undefined,
        menuVisible: false
      },
      contextMenuCoords: {},
      loading: true,
      source: null,
      style: null,
      annotationLayerPerPage: [],
      toolSize: 50,
      toolFilled: true,
      perPage: false,
      page: null,
      totalPages: 0,
      currentViewingPageNumber: "page-1",
      undoArr: [],
      redoArr: [],
      canvasLayerElements: [], 
      annotationLayerElements: [],
      textLayerElements: [],
      pageWidth: 1000, 
      pageHeight: 0,
      pageMargin: 8,
      pageDefaultWidth: null,
      pageScale: 2,
      zoomScale: 0.20,
      pageWidthIncreasePerZoom: 80,
      appContentElement: null,
      timeout: null,
      onlyOnce: true,
      textDialog: false,
      textAnnotationText: "",
      rotation: 0,
      searchText: "",
      pdfEnc: null,
      showTextLayer: true,
      showAnnotationLayer: true,
      debouncedCheckToSearch: _.debounce(this.checkToSearch, 400, { 'maxWait': 60000 }),
      searchResults: [],
      totalSearchResults: 0,
      lastScrollTop: 0,
      loadLibraryInSections: false,
      saveAnnotationsLoopTimeout: null
    };
  },
  watch: {
    hlPenMode: {
      immediate: true,
      handler(val) {
        switch (val) {
          case "highlighter":
            this.highlight()
            break;
          case "pen":
            this.drawing()
            break;
          case "textToSpeech":
            this.textToSpeech()

          default:
            this.deselect()
            this.textToSpeech()
            break;
        }
      }
    },
    hlPenSettings: {
      immediate: true,
      handler(val) {
        switch (this.hlPenMode) {
           case "highlighter":
            this.highlight()
            break;
          case "pen":
            this.drawing()
            break;

          default:
            this.deselect()
            break;
        }
      },
      deep: true
    },
    search: {
      immediate: true,
      handler (search) {
        storeHelpers.checkActive(this);
        this.debouncedCheckToSearch();
      }
    },
    selectedVoice: {
      immediate: true,
      handler(val) {
        this.setTTSVoice(this.voiceList[val])
      }
    },
    textToSpeechRate: {
      immediate: true,
      handler(val) {
        this.setTTSRate(val)
      }
    },
    textToSpeechVolume: {
      immediate: true,
      handler(val) {
        this.setTTSVolume(val)
      }
    },
    TTSPaused: {
      immediate: true,
      handler(val) {
        if (val == true)
          this.pauseTextToSpeech()
        else
          this.resumeTextToSpeech()
      }
    },
    TTSPlaying: {
      immediate: true,
      handler(val) {
        if (val == false) {
          this.stopTextToSpeech()
        }
      }
    },
    currentPage: {
      immediate: false,
      handler(val, oldVal) {
        storeHelpers.addPageOpened(this, this.book.id, val.oneBasedIndex, 1);
        var elem = document.getElementById("page-" + val.oneBasedIndex)
        var pdfViewer = document.getElementsByClassName("pdf-viewer")
        if (elem && pdfViewer && val.method != 'scroll') {
          document.removeEventListener("scroll", this.onscrollEvent)
          var y = elem.offsetTop - pdfViewer[0].offsetTop
          window.scrollTo({top: y, behavior: 'smooth'});
          // update active annotationLayerPerPage...
          var t = this
          setTimeout(() => {
            document.addEventListener("scroll", t.onscrollEvent)
          }, 600);
        } else if (this.loadLibraryInSections == true) {
          if (val.oneBasedIndex > oldVal.oneBasedIndex) {
            this.updateAnnotationLayerPerPage(true)
          } else if (val.oneBasedIndex < oldVal.oneBasedIndex) {
            this.updateAnnotationLayerPerPage(false)
          }
        } else if (this.perPage == true) {
          this.page = val.oneBasedIndex
        }

      }
    },
    showAnnotations: {
      immediate: true,
      handler(val) {
        this.viewAnnotations(val)
      }
    },
    scaleZoom: {
      immediate: true,
      handler(val, oldVal) {
        if (oldVal != undefined) this.zooming()
      }
    }
  },
  mounted() {
    this.PDFPERPAGE = this.$config.get("pdfPerPage") || 100
    var viewportWidth = window.innerWidth
    if (this.pageDefaultWidth == null) {
      this.pageDefaultWidth = this.pageWidth
    }
    var marginSize = (viewportWidth - this.pageWidth) / 2 - 25
    
    var css = `
      .vue-pdf-embed > div {
        margin-bottom: ` + this.pageMargin + `px !important;
        box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
      }
      .app-content {
        display: flex;
        margin-top: 80px;
        margin-left: ` + marginSize + `px;
        margin-right: ` + marginSize + `px;
        margin-bottom: 60px;
      }
    `;
    this.style = document.createElement("style");
    if (this.style.styleSheet) {
      this.style.styleSheet.cssText = css;
    } else {
      this.style.appendChild(document.createTextNode(css));
    }
    document.getElementsByTagName("body")[0].appendChild(this.style);

    if (this.metadata.totalPages > this.PDFPERPAGE) {
      this.perPage = true
      this.page = this.currentPage.oneBasedIndex
    }

    this.loadBook()
    
  },
  destroyed() {
    clearTimeout(this.saveAnnotationsLoopTimeout)
    this.saveAnnotationsLoopTimeout = null
  },
  methods: {
    viewAnnotations(val) {
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.hideAll(!val)
      }
    },
    saveAnnotationsLoop() {
      var t = this
      this.saveAnnotationsLoopTimeout = setTimeout(() => {
        t.exportAnnotations()
        t.saveAnnotationsLoop()
      }, 15000);
    },
    async loadBook() {
      const {bookUrl, pw, error} = await pdfUtils.loadPDF(this, this.book, this.metadata);

      if (error) {
        console.error(error)
      }

      this.pdfEnc = pw
      this.source = bookUrl      
    },
    handlePasswordRequest(callback, retry) {
      callback(this.pdfEnc)
    },
    async createAnnotationLayersePerPage() {
      this.annotationLayerPerPage = []
      this.onlyOnce = false
      this.appContentElement = document.getElementsByClassName("app-content")[0]
      this.canvasLayerElements = document.getElementsByTagName("canvas")
      this.annotationLayerElements = document.getElementsByClassName("annotationLayer")
      this.textLayerElements = document.getElementsByClassName("textLayer")

      if (this.perPage == false) {
        this.loading = true
        if (this.metadata.totalPages >= 30 && this.loadLibraryInSections == true) {
          var currentPageIndex = this.currentPage.oneBasedIndex - 1
          var totalBackPages = 10
          var totalFrontPages = 10
          if (currentPageIndex < 9) {
            totalBackPages = currentPageIndex
            totalFrontPages = 10 + totalBackPages - totalBackPages
          }

          if (currentPageIndex > this.metadata.totalPages - 10) {
            totalFrontPages = this.metadata.totalPages - currentPageIndex
            totalBackPages = 10 + totalFrontPages - totalFrontPages
          }

          for (var i = totalBackPages; i > 0; i--) {
            var detectedOrientation = this.detectOrientation(this.canvasLayerElements[currentPageIndex-i-1])
            this.annotationLayerPerPage.push({
              annotationObject: await new AnnotationLayer(this.annotationLayerElements[currentPageIndex-i-1], this.textLayerElements[currentPageIndex-i-1], this.canvasLayerElements[currentPageIndex-i-1], this.scaleZoom, this.zoomScale, this.pageWidthIncreasePerZoom, detectedOrientation, this.perPage),
              documentListener: this.textLayerElements[currentPageIndex-i-1],
              page: currentPageIndex-i
            })
          }

          for (var i = 0; i < totalFrontPages; i++) {
            var detectedOrientation = this.detectOrientation(this.canvasLayerElements[currentPageIndex+i])
            this.annotationLayerPerPage.push({
              annotationObject: await new AnnotationLayer(this.annotationLayerElements[currentPageIndex+i], this.textLayerElements[currentPageIndex+i], this.canvasLayerElements[currentPageIndex+i], this.scaleZoom, this.zoomScale, this.pageWidthIncreasePerZoom, detectedOrientation, this.perPage),
              documentListener: this.textLayerElements[currentPageIndex+i],
              page: currentPageIndex+i+1
            })
          }
        } else {
          for (var i = 0; i < this.annotationLayerElements.length; i++) {
            var detectedOrientation = this.detectOrientation(this.canvasLayerElements[i])
            this.annotationLayerPerPage.push({
              annotationObject: await new AnnotationLayer(this.annotationLayerElements[i], this.textLayerElements[i], this.canvasLayerElements[i], this.scaleZoom, this.zoomScale, this.pageWidthIncreasePerZoom, detectedOrientation, this.perPage),
              documentListener: this.textLayerElements[i],
              page: i+1
            })
          }
        }
      } else {
        var detectedOrientation = this.detectOrientation(this.canvasLayerElements[0])
        this.annotationLayerPerPage.push({
          annotationObject: await new AnnotationLayer(this.annotationLayerElements[0], this.textLayerElements[0], this.canvasLayerElements[0], this.scaleZoom, this.zoomScale, this.pageWidthIncreasePerZoom, detectedOrientation, this.perPage),
          documentListener: this.textLayerElements[0],
          page: this.$route.params.currentPage
        })

        this.deselect()
        // update eventlisteners to new page if HLmode or DrawMode is active
        var t = this
        setTimeout(() => {
          if (t.hlPenMode == "highlighter") {
            t.highlight()
          } else if (t.hlPenMode == "pen") {
            t.drawing()
          } else if (t.hlPenMode == "textToSpeech") {
            t.textToSpeech(true)
          }
        }, 300);
        
      }
      this.totalPages = this.$refs.pdfViewer.pageCount

      var elem = document.getElementById("page-" + this.$route.params.currentPage)
      var pdfViewer = document.getElementsByClassName("pdf-viewer")
      if (elem && pdfViewer) {
        var y = elem.offsetTop - pdfViewer[0].offsetTop
        window.scrollTo({top: y, behavior: 'instant'});
      }
      this.init()
    },
    init() {
      this.createContextMenuListener();
      // storeHelpers.clearPdfMemory(this, this.book.id)
      var memory = storeHelpers.getPdfMemory(this, this.book.id, this.perPage == true ? this.$route.params.currentPage : null)
      this.loadExternalAnnotations(memory)
      // this.saveAnnotationsLoop() // start save loop
      document.addEventListener("scroll", this.onscrollEvent)
      this.onPageLoading(false);
    },
    async updateAnnotationLayerPerPage(goingDown) {
      if (this.metadata.totalPages >= 30) {
      var currentPageIndex = this.currentPage.oneBasedIndex - 1
      // if (currentPageIndex <= this.metadata.totalPages - 10) {
        if (goingDown == true) {
          var lastAnnotationLayerPerPage = this.annotationLayerPerPage.at(-1)
          // shift this.annotationLayerPerPage - remove first
          if (currentPageIndex <= this.metadata.totalPages - 10) {
            this.annotationLayerPerPage.shift()
            // get last in annotationLayerPerPage
            var detectedOrientation = this.detectOrientation(this.canvasLayerElements[lastAnnotationLayerPerPage.page])
            // add one to this.annotationLayerPerPage
            this.annotationLayerPerPage.push({
              annotationObject: await new AnnotationLayer(this.annotationLayerElements[lastAnnotationLayerPerPage.page], this.textLayerElements[lastAnnotationLayerPerPage.page], this.canvasLayerElements[lastAnnotationLayerPerPage.page], this.scaleZoom, this.zoomScale, this.pageWidthIncreasePerZoom, detectedOrientation, this.perPage),
              documentListener: this.textLayerElements[lastAnnotationLayerPerPage.page],
              page: lastAnnotationLayerPerPage.page+1
            })
          }
        }
        // if (currentPageIndex >= 9) {
        if (goingDown == false) {
          // get last in annotationLayerPerPage
          var firstAnnotationLayerPerPage = this.annotationLayerPerPage[0]
          // pop this.annotationLayerPerPage
          if (currentPageIndex >= 9) {
            this.annotationLayerPerPage.pop()
            var detectedOrientation = this.detectOrientation(this.canvasLayerElements[firstAnnotationLayerPerPage.page - 2])
            // unshift one to this.annotationLayerPerPage
            this.annotationLayerPerPage.unshift({
              annotationObject: await new AnnotationLayer(this.annotationLayerElements[firstAnnotationLayerPerPage.page - 2], this.textLayerElements[firstAnnotationLayerPerPage.page - 2], this.canvasLayerElements[firstAnnotationLayerPerPage.page - 2], this.scaleZoom, this.zoomScale, this.pageWidthIncreasePerZoom, detectedOrientation, this.perPage),
              documentListener: this.textLayerElements[firstAnnotationLayerPerPage.page],
              page: firstAnnotationLayerPerPage.page - 1
            })
          }
        }
      }
    },
    async onscrollEvent() {
      if (this.perPage == false) {
        this.isUserScrolling = true
        const viewportHeight = window.innerHeight

        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > this.lastScrollTop) {
          // downscroll code
          for (let annotationLayerPage of this.annotationLayerPerPage) {
            var cbound = annotationLayerPage.documentListener.getBoundingClientRect()
            if (cbound.top > 0 && cbound.top < (viewportHeight/2)) {
              this.currentPage.method = "scroll"
              this.onCurrentPageChanged(Math.min(this.totalPages, annotationLayerPage.page), "scroll");
              break
            }
            
          }
        } else if (st < this.lastScrollTop) {
          // upscroll code
          for (let annotationLayerPage of this.annotationLayerPerPage) {
            var cbound = annotationLayerPage.documentListener.getBoundingClientRect()
            if (cbound.top < viewportHeight && cbound.top > (viewportHeight /2)) {
              this.currentPage.method = "scroll"
              this.onCurrentPageChanged(Math.min(this.totalPages, annotationLayerPage.page-1), "scroll");
              break
            }
            
          }
        } // else was horizontal scroll
        this.lastScrollTop = st <= 0 ? 0 : st;
      }

    },
    loadExternalAnnotations(importJsonStructurePerPage) {
      if (importJsonStructurePerPage != null) {
        if (this.perPage == false) {
          for (var annotation of importJsonStructurePerPage) {
            this.annotationLayerPerPage[annotation.pageData.pageNr - 1].annotationObject.loadAnnotationMemory(annotation.pageData.data, this.annotationLayerElements[annotation.pageData.pageNr - 1])
          }
        } else {
          this.annotationLayerPerPage[0].annotationObject.loadAnnotationMemory(importJsonStructurePerPage.pageData.data, this.annotationLayerElements[0])
        }
      }
      if (this.perPage == true && this.showAnnotations == false) {
        this.viewAnnotations(this.showAnnotations)
      }
    },
    detectOrientation(page) {
      var pageCbound = page.getBoundingClientRect()
      return pageCbound.width < pageCbound.height ? "portrait" : "landscape"
    },
    highlight() {
      const hlColor = annotationUtils.hlIndexToColor(this.hlPenSettings.hlColor);
      if (hlColor == "#000000") {
        this.clearTool()
        return
      }
      for (let annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.setClickMode("highlight", null, {
          color: hlColor
        })
        this.textLayerElements[this.perPage == true ? 0 : annotationLayerPage.page-1].addEventListener("click", this.clickHandler)
      }
    },
    clearTool() {
      for (let annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.setClickMode("clearTool", null, null)
        this.textLayerElements[this.perPage == true ? 0 : annotationLayerPage.page-1].addEventListener("click", this.clickHandler)
      }
    },
    drawing() {
      const hlColor = annotationUtils.hlIndexToColor(this.hlPenSettings.penColor);
      if (hlColor == "#000000") {
        this.clearTool()
        return
      }
      for (let annotationLayerPage of this.annotationLayerPerPage) {
        var drawingCanvas = annotationLayerPage.annotationObject.setDrawMode("drawing", null, {
          color: hlColor,
          lineThickness: this.hlPenSettings.lineThickness
        })
        drawingCanvas.addEventListener("click", this.clickHandler)
      }
    },
    clickHandler() {
      this.exportAnnotations()
    },
    deselect() {
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.deselectTool()
      }
    },
    checkToSearch() {
      this.searchResults = [];
      if (this.search && this.search.length > 1 && this.totalSearchResults < 200) {
        this.totalSearchResults = 0;

        // show search
        this.searchShow(this.search)
      } else {
        // clear search
        this.searchClear()
        this.totalSearchResults = 0;
        this.$emit("searchResults", this.searchResults);
      }
    },
    searchShow(search) {
      var searchResults = []
      
      for (var annotationLayer of this.annotationLayerPerPage) {
        searchResults.push(annotationLayer.annotationObject.highlightSearch(search))
      }
      
      this.searchResults = []
      for (var [index, resultPage] of searchResults.entries()) {
        for (var resultText of resultPage) {
          this.searchResults.push({
            page: index + 1,
            text: resultText,
          })
        }
      }
      this.$emit("searchFound", this.searchResults)
    },

    searchClear() {
      for (var annotationLayer of this.annotationLayerPerPage) {
        annotationLayer.annotationObject.searchClear()
      }
      this.searchResults = []
    },

    textToSpeech(pageChanged = false) {
      if (pageChanged == false)
        this.TTSMode = !this.TTSMode
      if (this.TTSMode == true) {
        this.$emit("TTSPlaying", true)
        for (var annotationLayerPage of this.annotationLayerPerPage) {
          annotationLayerPage.annotationObject.textToSpeech(this.voiceList[this.selectedVoice], this.textToSpeechRate, this.textToSpeechVolume)
        }
      } else {
      this.$emit("TTSPlaying", false)
        for (var annotationLayerPage of this.annotationLayerPerPage) {
          annotationLayerPage.annotationObject.cancelTextToSpeech()
        }
      }
    },
    pauseTextToSpeech() {
      this.$emit("TTSPaused", true)
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.pauseTextToSpeech()
      }
    },
    resumeTextToSpeech() {
      this.$emit("TTSPaused", false)
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.resumeTextToSpeech()
      }
    },
    stopTextToSpeech() {
      this.$emit("TTSPlaying", false)
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.stopTextToSpeech()
      }
    },
    setTTSVoice(selectedVoice) {
      this.$emit("TTSPlaying", false)
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.setTTSVoice(selectedVoice)
      }
    },
    setTTSRate(rate) {
      this.$emit("TTSPlaying", false)
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.setTTSRate(rate)
      }
    },
    setTTSVolume(volume) {
      this.$emit("TTSPlaying", false)
      for (var annotationLayerPage of this.annotationLayerPerPage) {
        annotationLayerPage.annotationObject.setTTSVolume(volume)
      }
    },
    zooming() {
      this.appContentElement.style.width -= this.pageWidthIncreasePerZoom
      const viewportWidth = window.innerWidth
      this.pageScale = 2 + (this.zoomScale * this.scaleZoom)
      this.pageWidth = this.pageDefaultWidth + (this.pageWidthIncreasePerZoom * this.scaleZoom)
      var margin = (viewportWidth - this.pageWidth) / 2 - 25 + "px"
      this.appContentElement.style.marginLeft = margin
      this.appContentElement.style.marginRight = margin
      for (var page of document.getElementById("page").childNodes) {
        page.style.width = this.pageWidth + "px"
      }
      var wrapper = document.getElementById("page")
      wrapper.style.width = Math.floor(viewportWidth/this.pageScale) + "px"
      this.updateLayers()
      this.$refs.pdfViewer.load()
    },
    updateLayers() {
      setTimeout(() => {
        for (var annotationLayer of this.annotationLayerPerPage) {
          annotationLayer.annotationObject.zoom = this.zoom
          annotationLayer.annotationObject.pageScale = this.pageScale
          annotationLayer.annotationObject.updateLayer()
        }
      }, 200);
    },
    exportAnnotations() {
      var exportPerPage = []
      for (let annotationLayerPage of this.annotationLayerPerPage) {
        var pageData = annotationLayerPage.annotationObject.exportAnnotations()
        if (pageData.length > 0) {
          exportPerPage.push({
            pageData: {
              pageNr: annotationLayerPage.page,
              data: pageData
            },
          })
        }
      }
      if (this.perPage == true)
        storeHelpers.setPdfMemory(this, exportPerPage, this.book.id, true, this.currentPage.oneBasedIndex)
      else
        storeHelpers.setPdfMemory(this, exportPerPage, this.book.id)
    },
    setContextMenuPosition(origin, absoluteOrigin) {
      this.contextMenu.el.style.left = `${origin.left}px`;
      this.contextMenu.el.style.top = `${origin.top}px`;
      this.contextMenuCoords.y = absoluteOrigin.top
      this.contextMenuCoords.x = absoluteOrigin.left
      this.toggleContextMenu(true);
    },
    toggleContextMenu(visible) {
      this.contextMenu.el.style.display = visible && !this.contextMenuListItemOpen ? "inline-block" : "none";
      this.contextMenu.menuVisible = visible;
      this.$emit("toggleContextMenu", {
        "menuVisible" : this.contextMenu.menuVisible, 
        "section": this.currentPage.oneBasedIndex.toString()
      });
    },
    createContextMenuListener() {
      this.contextMenu.el = document.querySelector(".menu");
      if (document.addEventListener) { // IE >= 9; other browsers
        document.addEventListener('contextmenu', this.contextMenuListener, false);
      } else { // IE < 9
        document.attachEvent('oncontextmenu', () => {
          this.contextMenu = false;
          document.event.returnValue = false;
        });
      }
      
      document.addEventListener("click", e => {
        if (this.contextMenu.menuVisible) {
          this.toggleContextMenu(false);
        }
      });
      document.addEventListener("click", e => {
        if (this.contextMenu.menuVisible) {
          this.toggleContextMenu(false);
        }
      });
    },
    contextMenuListener(e) {
      e.preventDefault();
      const origin = {
        left: e.pageX + 4,
        top: e.pageY
      };
      const absoluteOrigin = {
        left: e.x + 4,
        top: e.y + 116
      }
      this.setContextMenuPosition(origin, absoluteOrigin);

      var currentPage = this.findPage(this.contextMenuCoords.y)
      var topAndBottom = bookUtils.getPDFPageTopAndBottom(currentPage)
      var topFromPage = topAndBottom.top - this.contextMenuCoords.y
      var selector = topFromPage / (topAndBottom.bottom - topAndBottom.top) * 100
      selector = selector && selector > 0 ? selector : 0;
      this.$emit("contextMenuSelector", selector.toString()); 
    },
    findPage(y) {
     for (let annotationLayerPage of this.annotationLayerPerPage) {
        var cbound = annotationLayerPage.documentListener.getBoundingClientRect()
        if (y > cbound.top && y < cbound.top + cbound.height) {
          return annotationLayerPage.page
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>